import { Injectable } from '@angular/core';
import { clone, isUndefined, pick, map as lodashMap, filter as lodashFilter } from 'lodash-es';
import { TreeviewItem } from '../../../shared/components/tree-view';
import { SectorIndustryMapping } from './sector-industry-mapping.service';
import { CommonUtilService } from '../../../shared/services/CommonUtil.service';
import { Observable, of, Subject, Subscriber } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})

export class SectorIndustry {
    sectors = [];
    mapping = {};
    tree = [];
    industryResponse: any;

    private readonly cancelSubject = new Subject<void>();

    constructor(
      public industry: SectorIndustryMapping,
      private commonUtilService: CommonUtilService
    ) { }

    public getIndustries(what) {
        const dataSet = clone(this.mapping);
        const siData = isUndefined(what) ? dataSet : pick(dataSet, what);
        let result;
        for (const key of Object.keys(siData)) {
            result = siData[key].industries.map(x => x.name);
        }
        return result;
    }

    nodify(sectorOrIndustryName, selection, mainSelected) {
        return new TreeviewItem({
            'value': this.industry.industryDataObject.mappingNameToNaics[sectorOrIndustryName],
            'text': sectorOrIndustryName,
            'checked': (selection.indexOf(sectorOrIndustryName) >= 0) || mainSelected,
            'collapsed': true,
            'children': []
        });
    }

    public buildTree(selectedSectorsAndIndustries) {
        this.sectors = this.industry.industryDataObject.sectors;
        this.mapping = this.industry.industryDataObject.mapping;

        const selectedSectorAndIndustryNames = lodashMap(selectedSectorsAndIndustries, (item) => {
            return this.industry.industryDataObject.mappingNaicsToName[item];
        });

        const treeViewItemList: TreeviewItem[] = this.sectors.map((item: string) =>
          this.nodify(item, selectedSectorAndIndustryNames, false)
        );

        treeViewItemList.forEach((node: TreeviewItem) => {
          const industries = this.getIndustries(node.text);

          node.children = lodashMap(industries, (key, value) => {
            const newNode = this.nodify(key, selectedSectorAndIndustryNames, node.checked);
            delete newNode['children'];
            return newNode;
          });

          const nodeSelectionCount = lodashFilter(node.children, (item) => item.checked).length;

          // collapse if none selected or if all selected
          node.collapsed = (
            nodeSelectionCount === 0 ||
            nodeSelectionCount === node.children.length
          );
        })

        this.tree = clone(treeViewItemList);
        return this.tree;
    }

    init(): Observable<boolean> {
        this.cancelSubject.next();

        return new Observable((subscriber: Subscriber<boolean>) => {
            if (!!this.industryResponse) {
                subscriber.next(true);
                subscriber.complete();
                return;
            }

            this.industry.getIndustryData().pipe(takeUntil(this.cancelSubject)).subscribe((response) => {
                if (response) {
                    const mappingIndustryData = this.industry.mappingOfInsdustryData(response);
                    if (mappingIndustryData) {
                        this.tree = this.buildTree([]);
                        this.industryResponse = response;
                    }
                }
                subscriber.next(true);
                subscriber.complete();
            }, () => {
                subscriber.next(true);
                subscriber.complete();
            });
        });
    }
}

